import React, { useState, useEffect, forwardRef, useRef } from 'react';
import _ from 'lodash-es';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {  showAlert } from '../../../../../../Assests/Utility';
import { AppConstant } from '../../../../../../Assests/AppConstant';
import { sagaActions } from '../../../../../../../sagas/sagaActions';

import { getUserSelector } from '../../../../../../../redux/reducers/reducerSlices/UserReducer';
import { getWhMetaDataReducerSlice } from '../../../../../../../redux/reducers/reducerSlices/WhMetaDataReducerSlice';
import './Docks.css';
import SSPopup from '../../../../../Common/Popup/SSPopup/SSPopup';
import WarehouseSearchSS from '../../../../../SuperWarehouse/Components/SearchWarehouse/WarehouseSearchSS';
import { useNavigate } from 'react-router-dom';


import AddCapacityMangementSlots from '../../../../../SmartSchedule/SchedulePro/Components/Common/Popups/AddCapacityMangementSlots';
import DockCapacityMangementList from './DockList/DockCapacityMangementList';


const DockCapacityMangement = (props) => {
  const {
    themeSelected,
    editGroupAction,
    allowPermissionE = true,
    allowPermissionD,
    whObj,
  } = props;
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
    const [showSlotsModal, setShowSlotsModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [searchStr, setSearchStr] = useState("");
  const [loading, setLoading] = useState(false);
  const whMetaData = useSelector(getWhMetaDataReducerSlice);
  const {
    operationObj,
    preCheckList,
    dockTypeList,
    isLoading,
    capacityManagementList,
  } = whMetaData;
  const user = useSelector(getUserSelector);
  const { cu_id, selectedWarehouse } = user;
  const [showPreCheckModal, setShowPreCheckModal] = useState(false);
  const firstUpdate = useRef(true);
  const navigate = useNavigate();






  useEffect(() => {
    setTimeout(() => {
    fetchDockCapacityList();
    }, 0);
    return() => {dispatch({ type: sagaActions.RESET_SS_PO_OPERATION_OBJ });}
  }, []);

const fetchDockCapacityList = () => {
    const operationObj = {
      type: "Fetch",
      status: "",
    };
    dispatch({
      type: sagaActions.GET_CAPACITY_MANAGEMENT_DETAILS,
      payload: { CRUDTYPE: "S", IDWarehouse: selectedWarehouse.ID },
      operationObj: operationObj,
    });
}



  useEffect(() => {
    dispatch({ type: sagaActions.UPDATE_PRE_CHECK_LIST, payload: [] });
    setLoading(false);
    setShowModal(false);
  }, []);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    if (preCheckList.length > 0) {
      setShowModal(false);
      setLoading(false);
      setShowPreCheckModal(true);
    }
  }, [preCheckList]);

  useEffect(() => {
    if (operationObj.type) {
      switch (operationObj.type) {
        case "Add":
          if (operationObj.status) {
            setShowSlotsModal(false);
            handleApiResponse(
              AppConstant.notifications.dataAddedSuccess,
              AppConstant.smartScheduler.docks.createDockSuccess
            );
          } else {
            handleApiResponse(
              AppConstant.commonStrings.failure,
              AppConstant.smartScheduler.docks.createDockFailure
            );
          }
          break;
        case "Edit":
          if (operationObj.status) {
            setEditData({});
            setShowSlotsModal(false);
            handleApiResponse(
              AppConstant.notifications.dataAddedSuccess,
              AppConstant.smartScheduler.docks.updateDockStatusSuccess
            );
          } else {
            handleApiResponse(
              AppConstant.commonStrings.failure,
              AppConstant.smartScheduler.docks.updateDockFailure
            );
          }
          break;

        case "Delete":
          if (operationObj.status) {
            handleApiResponse(
              AppConstant.notifications.dataAddedSuccess,
              AppConstant.smartScheduler.docks.updateDockStatusSuccess
            );
          } else {
            handleApiResponse(
              AppConstant.commonStrings.failure,
              AppConstant.smartScheduler.docks.updateDockFailure
            );
          }
          break;

        case "Remove":
          if (operationObj.status) {
            handleApiResponse(
              AppConstant.notifications.dataAddedSuccess,
              AppConstant.smartScheduler.dockCapacityMangement.removeSuccess
            );
          } else {
            handleApiResponse(
              AppConstant.commonStrings.failure,
              AppConstant.smartScheduler.dockCapacityMangement.removeFailure
            );
          }
          break;
        default:
      }
    }
  }, [operationObj]);

  const handleApiResponse = (result, message) => {
    if (result === AppConstant.notifications.dataAddedSuccess) {
      showAlert(toast.TYPE.SUCCESS, message, themeSelected);
      setShowModal(false);
      fetchDockCapacityList();
    } else {
      showAlert(toast.TYPE.ERROR, message, themeSelected);
    }
    setLoading(false);
    dispatch({ type: sagaActions.RESET_SS_PO_OPERATION_OBJ });
  };




  const editDock = (data) => {
    const editData1 = {
    ...data
    };
    setShowSlotsModal(true);
    setEditData(editData1);

    
  };



  const closePreCheckpopup = () => {
    setShowPreCheckModal(false);
  };

  const popupBtnHandler = (text) => {
    if (text === AppConstant.commonStrings.viewDetailsStr) {
      navigate("/manageappointments");
    } else {
      setShowPreCheckModal(false);
    }
  };

  const showPreCheck = () => {
    const popupObj = {
      id: "adminUpdateOperationPreCheck",
      modalLabel: "adminUpdateOperationPreCheck",
      showClose: true,
      showfooter: true,
      showHeader: true,
      sendDriverNotification: false,
      modalSize: "md",
      title: AppConstant.smartScheduler.docks.editDockTitle,
      bodyText: AppConstant.superUserAdmin.warehouseAdmin.preCheckBockerMsg,
      subText: "",
      keyboard: false,
      backdrop: "static",
      footerBtn: {
        btn1: {
          show: true,
          text: AppConstant.commonStrings.viewDetailsStr,
        },
        btn2: {
          show: false,
          text: AppConstant.commonStrings.close,
        },
      },
    };

    return (
      <SSPopup
        {...popupObj}
        popupBtnHandler={(text) => {
          popupBtnHandler(text);
        }}
        closepopup={() => {
          closePreCheckpopup();
        }}
        themeSelected={themeSelected}
        showModal={showPreCheckModal}
      />
    );
  };

  const genratePayload = (data,IDDock,type) => {
    if (type.toUpperCase() === "ADD") {
      return {
        IDDock: IDDock,
        CRUDTYPE: "I",
        IDWarehouse: whObj.ID,
        CreatedOn: new Date().toISOString(),
        CreatedBy: cu_id,
        Status: false,
        slots: data,
      };
        
    }else if (type.toUpperCase() === "EDIT") {
      return {
        ID: data?.ID || null,
        IDDock: IDDock,
        CRUDTYPE: "U",
        IDWarehouse: whObj.ID,
        CreatedOn: editData.CreatedOn ? editData.CreatedOn : new Date().toISOString(),
        CreatedBy: editData.CreatedBy ? editData.CreatedBy : cu_id,
        UpdatedBy: cu_id,
        Status: editData.Status ? editData.Status : false,
        UpdatedOn: new Date().toISOString(),
        slots: data,
      };
    }
    else if (type.toUpperCase() === "REMOVE") {
      return {
        IDDock: IDDock,
        CRUDTYPE: "DS",
        IDWarehouse: whObj.ID,
        slots: [data],
      };
    }
  }

  const onFormSubmit = (data,IDDock,type) => {
    const payload = genratePayload(data,IDDock,type);
    let operationObj;
    if (type.toUpperCase() === "ADD") {
         operationObj = {
          type: "Add",
          status: "",
        };
    }else if (type.toUpperCase() === "EDIT") {
      operationObj = {
        type: "Edit",
        status: "",
      };
    }
    else if (type.toUpperCase() === "REMOVE") {
      operationObj = {
        type: "Remove",
        status: "",
      };
    }
  
    dispatch({
      type: sagaActions.GET_CAPACITY_MANAGEMENT_DETAILS,
      payload: payload,
      operationObj: operationObj,
    })
  }

      const openCapacityMangementSlots = () => {
        return (
          <AddCapacityMangementSlots
            actionHandler={(data, IDDock, type) => {
              onFormSubmit(data, IDDock, type);
            }}
            whObj={whObj}
            editData={editData}
            initateLoading={isLoading}
          />
        );
      };

     const showSlotsPopup = () => {
       const popupObj = {
         id: "showSlotsPopup",
         modalLabel: "showSlotsPopup",
         showClose: true,
         showfooter: false,
         showHeader: true,

         sendDriverNotification: false,
         modalSize: "xl",
         title: "Add Capacity Management Slots",
         bodyText: openCapacityMangementSlots(),
         subText: "",
         keyboard: false,
         backdrop: "static",
         footerBtn: {
           btn1: {
             show: true,
             text: AppConstant.comments.cancelCommentButtonTitle,
           },
           btn2: {
             show: true,
             text: AppConstant.superUserAdmin.warehouseAdmin.createWarehouseForm
               .saveButtonTitle,
           },
         },
       };

       return (
         <SSPopup
           {...popupObj}
           type="info"
           alignType="center"
           popupBtnHandler={(text) => () => ""}
           closepopup={()=>{
            setEditData({});
            setShowSlotsModal(false)
          }}
           themeSelected={themeSelected}
           showModal={showSlotsModal}
         />
       );
     };

  return (
    <div>
      <div className="container-fluid d-flex py-2 text-start justify-content-between mt-1">
        <button
          className={"btn-highlighted f-12 me-3"}
          data-bs-toggle="modal"
          onClick={() => setShowSlotsModal(true)}
        >
          Add Slots
        </button>
        <div className="ms-5">
          <WarehouseSearchSS
            placeholder={"Search Docks"}
            inputValue={searchStr}
            cancelSearch={() => setSearchStr("")}
            onChangeHandler={(text) => setSearchStr(text)}
          />
        </div>
      </div>
      <div className="d-flex justify-content-center metaDockList">
        <DockCapacityMangementList
          searchStr={searchStr}
          editDockAction={(groupObj) => editDock(groupObj)}
          showPopup={() => setShowSlotsModal(true)}
          themeSelected={themeSelected}
          allowPermissionE={allowPermissionE}
          allowPermissionD={allowPermissionD}
          whObj={whObj}
        />
        {showSlotsPopup()}
        {showPreCheck()}
      </div>
    </div>
  );
};

export default DockCapacityMangement;